/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SlowFolderEntryInfo } from '../../models/slow-folder-entry-info';

export interface FolderControllerSlowListFolderContent$Params {
  folderId: string;
}

export function folderControllerSlowListFolderContent(http: HttpClient, rootUrl: string, params: FolderControllerSlowListFolderContent$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SlowFolderEntryInfo>>> {
  const rb = new RequestBuilder(rootUrl, folderControllerSlowListFolderContent.PATH, 'get');
  if (params) {
    rb.path('folderId', params.folderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SlowFolderEntryInfo>>;
    })
  );
}

folderControllerSlowListFolderContent.PATH = '/folder/listSlow/{folderId}';
